import { render, staticRenderFns } from "./modalAnexosGenerico.vue?vue&type=template&id=06efd3c6"
import script from "./modalAnexosGenerico.vue?vue&type=script&lang=js"
export * from "./modalAnexosGenerico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports